import { format, formatDistanceToNow, parseISO } from 'date-fns';
import { ro } from 'date-fns/locale';

export function formatData(dateStr) {
  if (!dateStr) return '—';
  try {
    return format(parseISO(dateStr), 'dd.MM.yyyy', { locale: ro });
  } catch { return '—'; }
}

export function formatDataOra(dateStr) {
  if (!dateStr) return '—';
  try {
    return format(parseISO(dateStr), 'dd.MM.yyyy HH:mm', { locale: ro });
  } catch { return '—'; }
}

export function formatRelativ(dateStr) {
  if (!dateStr) return '—';
  try {
    return formatDistanceToNow(parseISO(dateStr), { addSuffix: true, locale: ro });
  } catch { return '—'; }
}

export function formatBytes(bytes) {
  if (!bytes) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB'];
  let i = 0;
  let val = bytes;
  while (val >= 1024 && i < units.length - 1) { val /= 1024; i++; }
  return `${val.toFixed(1)} ${units[i]}`;
}

export const TIP_LABELS = {
  sesizare:   'Sesizare',
  solicitare: 'Solicitare',
  petitie:    'Petiție',
  reclamatie: 'Reclamație',
  informatie: 'Cerere informații',
};

export const STATUS_LABELS = {
  inregistrata: 'Înregistrată',
  in_analiza:   'În analiză',
  in_lucru:     'În lucru',
  rezolvata:    'Rezolvată',
  respinsa:     'Respinsă',
  arhivata:     'Arhivată',
};

export const ROL_LABELS = {
  cetatean:         'Cetățean',
  functionar:       'Funcționar',
  sef_departament:  'Șef departament',
  secretar_general: 'Secretar General',
  admin:            'Administrator',
  primar:           'Primar',
  superadmin:       'Super Admin',
};

export function truncate(str, maxLen = 80) {
  if (!str) return '';
  return str.length > maxLen ? str.slice(0, maxLen) + '…' : str;
}

// Link separat pentru cetățeni (portal.<domeniu>) vs. instituție (<domeniu>) — aceeași
// aplicație/build, doar UI-ul de login diferă vizual. Rolul/JWT-ul (nu subdomeniul)
// decid efectiv ce vede fiecare cont după autentificare.
export function isPortalCetatean() {
  return typeof window !== 'undefined' && window.location.hostname.startsWith('portal.');
}
